module.exports = __webpack_public_path__ + "media/images/redesign-images/careers/art/gallery/art-gallery-10-7594b57af900d1973e8ed9ed4b718cd4.jpg";